// src/clarity.js
import { clarity } from "react-microsoft-clarity";

const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

/**
 * Inicializa Microsoft Clarity.
 *
 * El enmascaramiento de datos sensibles se aplica de forma selectiva
 * solo en los componentes que manejan datos de pacientes, usando el
 * atributo data-clarity-mask="True" directamente en los elementos del DOM.
 *
 * Componentes que aplican enmascaramiento:
 * - SearchPatientPage     → input de búsqueda por RUT / Pasaporte / Ficha
 * - PreparationRequestPage → resumen del nombre del paciente en los pasos
 */
if (projectId) {
    clarity.init(projectId);
    if (process.env.NODE_ENV === 'development') {
        console.log("✅ Microsoft Clarity inicializado correctamente");
    }
} else {
    console.warn("⚠️ Microsoft Clarity NO está inicializado. Verifica REACT_APP_CLARITY_PROJECT_ID");
}
